import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { ReleaseNoteType } from "./types";
import { getContentPreview } from "./utils";

interface ReleaseListItemProps {
  release: ReleaseNoteType;
  onClick: (release: ReleaseNoteType) => void;
  /** Custom className for the item container */
  className?: string;
  /** Content preview character limit */
  previewLimit?: number;
}

const ReleaseListItem: React.FC<ReleaseListItemProps> = ({
  release,
  onClick,
  className = "w-full p-4 border-b border-[#eee] last:border-b-0 relative cursor-pointer border-l-4 border-l-transparent hover:bg-[#f5f9f8] hover:border-l-[#00463B] transition-colors duration-150",
  previewLimit = 20,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const isResourcesPath = location.pathname.startsWith("/resources");

  return (
    <div
      className={className}
      onClick={() => onClick(release)}
      role="button"
      tabIndex={0}
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="font-bold text-base text-[#00463B]">
          {release.title}
        </span>
        {!isResourcesPath && (
          <span
            className={`inline-block px-2 py-0.5 text-xs rounded ${release.status === "publish"
                ? "bg-[#e8f5e9] text-[#2e7d32]"
                : "bg-[#fff3e0] text-[#e65100]"
              }`}
          >
            {release.status === "publish"
              ? t("userSystem.statusPublish")
              : t("userSystem.statusDraft")}
          </span>
        )}
      </div>
      <div>
        <span className="text-[#777]">{release.version}</span>
        {" - "}
        <span className="text-[#333]">
          {getContentPreview(release.content, previewLimit)}
        </span>
      </div>
      <div className="material-icons text-[32px] absolute right-[1rem] top-6">
        chevron_right
      </div>
    </div>
  );
};

export default ReleaseListItem;
